import AddExperienceComponent from "../../../components/partner/add-experience";

export default function AddExperience() {
  return <AddExperienceComponent /> ;
}
